import React from "react";
import './products-banner.css'
const ProductsBanner=()=>{
    return(
<div className="product-banner-section">
      {/* Hero Section */}
      <div className="banner-section position-relative">
        <div className="banner-image">
          <img 
            src="/assets/bg/product-page-banner.png" 
            alt="banner background" 
            className="w-100 h-100 "
          />
          <div className="overlay"></div>
        </div>
        
        {/* Hero Content */}
        <div className="banner-content container text-end text-danger">
          <h1 className="display-4 fw-bold mb-4">Products</h1>
         
</div>
</div>
</div>
    )
}

export default ProductsBanner